__webpack_require__.p = "/varshanipreddy_portfolio/";